module.exports = __webpack_public_path__ + "img/a185d9f.png";